import http from "./requestBase";
import { FILES_STORE_NAME } from "./LocalDatabase/StoreNames";
import getLocalDB from "./LocalDatabase/GetLocalDB";
import uuidv4 from "uuid/v4";
import EXIF from "exif-js"

class UploadFilesService {
  constructor() {
    getLocalDB.then((result) => {
      this.localDB = result;
    });
  }
  saveFilesToDeleteOffline(files) {
    this.localDB.saveObject("app", "filesToDelete", files);
  }
  async getFilesToDelete() {
    try {
      return await this.localDB.getObject("app", "filesToDelete");
    } catch (err) {
      return [];
    }
  }
  async getOfflineKeys() {
    try {
      return await this.localDB.getObject("app", "offlineFileKeys");
    } catch (err) {
      return [];
    }
  }
  async clearCachedFilesExcept(fileGuid) {
    fileGuid = fileGuid.map((v) => {
      if (Array.isArray(v)) {
        v.forEach((element) => {
          element.toUpperCase();
        });
      } else {
        v.toUpperCase();
      }
    });
    let keys = (await this.getCachedKeys()).filter((v) => {
      fileGuid.indexOf(v) === -1;
    });
    for (let key of keys) {
      await this.uncacheFile(key);
    }
  }
  async getFullCacheRelatedKeys() {
    let keys = await this.getCachedKeys();
    if (keys.length > 0) {
      keys = keys.map((v) => "FILES_" + v);
      keys.push("__CACHEDFILEKEYS");
    }
    return keys;
  }
  saveOfflineKeys(offlineFileKeys) {
    this.localDB.saveObject("app", "offlineFileKeys", offlineFileKeys);
  }
  async getCachedKeys() {
    try {
      return await this.localDB.getObject("app", "cachedFileKeys");
    } catch (err) {
      return [];
    }
  }
  saveCachedKeys(cachedFileKeys) {
    this.localDB.saveObject("app", "cachedFileKeys", cachedFileKeys);
  }
  /**
   *
   * @param {File} file The file you want to Upload
   * @param {Function} progresscallback - optional callback for Progress event
   * @returns {Promise<R>} - returns the response in a Promise
   */
  async uploadOnline(file, onUploadProgress = (r) => {}) {
    let formData = new FormData();

    formData.append("file", file);
      let response = await http.post("api/Upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: onUploadProgress,
      });
      let id = response.data[0].DownloadId;

      try {
        await this.cacheFile(id, file);
      } catch (error) {}
      return id;
  }

  /**
   *
   * @param {String} baseKey The first part of the local key
   * @param {File} file The file you want to Upload
   * @returns {Promise<R>} - returns the response in a Promise
   */
  async uploadOffline(baseKey, file) {
    let key = baseKey + "_" + uuidv4();
    await this.localDB.saveFile(FILES_STORE_NAME, key, file);
    let offlineFileKeys = await this.getOfflineKeys();
    offlineFileKeys.push(key);
    this.saveOfflineKeys(offlineFileKeys);
    return key;
  }

  /**
   *
   * @param {String} key The file key
   * @param {File} file The file you want to Upload
   * @returns {Promise<R>} - returns the response in a Promise
   */
  async cacheFile(key, file) {
    await this.localDB.saveFile(FILES_STORE_NAME, key, file);
    let cachedFileKeys = await this.getCachedKeys();
    cachedFileKeys.push(key);
    this.saveCachedKeys(cachedFileKeys);
  }

  /**
   *
   * @param {String} key The file key
   * @returns {Promise<R>} - returns the response in a Promise
   */
  async uncacheFile(key) {
    let cachedFileKeys = await this.getCachedKeys();
    let newCachedFileKeys = [];
    for (let item of cachedFileKeys) {
      if (item === key) {
        this.localDB.remove(FILES_STORE_NAME, key);
      } else {
        newCachedFileKeys.push(item);
      }
    }
    this.saveCachedKeys(newCachedFileKeys);
  }

  /**
   *
   * @param {String} key The file key
   * @returns {Promise<R>} - returns the response in a Promise
   */
  async uploadOfflineFile(key) {
    let file = await this.getFileById(key);
    let newKey = await this.uploadOnline(file);
    let offlineFileKeys = await this.getOfflineKeys();
    this.localDB.saveObject(
      "app",
      "offlineFileKeys",
      offlineFileKeys.filter((v) => v != key)
    );
    return { oldKey: key, newKey: newKey };
  }

  /**
   *
   * @param {Array<String>} keys The list of keys to upload
   * @returns {Promise<Array<Object>>} - returns the response with array with new files keys
   */
  async uploadOfflineFiles(keys) {
    let newKeys = [];
    for (var key of keys) {
      if (await this.isOfflineKey(key)) {
        newKeys.push(await this.uploadOfflineFile(key));
      } else {
        newKeys.push({ oldKey: key, newKey: key });
      }
    }
    return newKeys;
  }
  /**
   *
   * @param {String} key The file key (id)
   * @returns {Promise<File>} - returns the response in a Promise
   */
  async getFileById(key) {
    if (!key) {
      console.debug("getFileById: !key");
      return;
    }

    let response = await http.get(`/api/Download/${key}`, {
      responseType: "blob",
    });

    return response.data;
  }

  /**
   *
   * @param {String} key The file key (id)
   * @returns {Promise<File>} - returns the response in a Promise
   */
  async getFileURLById(key) {
    let blob = await this.getFileById(key);
    if (blob && blob.size > 0) return URL.createObjectURL(blob);
  }

  /**
   *
   * @param {String} key The file key
   * @returns {Boolean} - returns if key is offline
   */
  async isOfflineKey(key) {
    let isOffline = false;
    isOffline = (await this.getOfflineKeys()).indexOf(key) > -1;
    if (!isOffline) {
      let questionRegex = /[q][0-9][0-9][0-9][0-9][0-9]_*/;
      isOffline = questionRegex.test(key);
    }
    return isOffline;
  }

  /**
   *
   * @param  {Array<SurveyInstanceAnswerFile>}files JSON of files like saved for SurveyInstanceAnswer
   * @returns
   */
  delete(files) {
    return http.post("api/Download/Delete", JSON.stringify(files));
  }

  // Delete file from file server
  deleteFile(id) {
    return http.delete(`api/Upload/DeleteFile/${id}`);
  }

  saveExifData(file, downloadId) {
    if (file.type === "image/jpeg") {
      console.log(file.type)
      EXIF.getData(file, function() {
        const exifData = EXIF.getAllTags(file);
        if(!_.isEmpty(exifData)){
          let exifJson = JSON.stringify(exifData, null, 2);
          http.post(`api/Upload/ExifData/${downloadId}`, exifJson)
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.error(err);
          })
        }
      });
    }
  }
}

export default new UploadFilesService();



// WEBPACK FOOTER //
// ./src/services/uploadService.js